export enum PaymentLinkOptionMode {
    ONE_OFF_FIXED = 'ONE_OFF_FIXED',
    REUSABLE_FIXED = 'REUSABLE_FIXED',
    REUSABLE_VARIABLE = 'REUSABLE_VARIABLE'
}

export enum PaymentReferenceMode {
    FIXED = 'FIXED',
    PAYER_INPUT = 'PAYER_INPUT',
    EDITABLE = 'EDITABLE'
}

export type PaymentLinkOptionType = {
    mode: PaymentLinkOptionMode
    paymentReferenceMode?: PaymentReferenceMode
    minAmount?: number
    maxAmount?: number
}
